import {
  DropdownVariant,
  GroupVariant,
  NavItemType,
  NavbarRendererVariant,
  type NavbarRendererProps
} from "./types";
import { isItemVisible } from "./utils";
import { Logo } from "./Logo";
import { NavLink } from "./NavLink";
import { Dropdown } from "./Dropdown";
import { Group } from "./Group";

export function NavbarRenderer({
  item,
  variant = NavbarRendererVariant.Top,
  onNavigate
}: NavbarRendererProps) {
  if (!isItemVisible(item)) return null;

  switch (item.type) {
    case NavItemType.Logo:
      return <Logo item={item} />;

    case NavItemType.Link:
      return <NavLink item={item} variant={variant} onNavigate={onNavigate} />;

    case NavItemType.Dropdown:
      return (
        <Dropdown
          item={item}
          variant={
            variant === NavbarRendererVariant.Menu
              ? DropdownVariant.Submenu
              : variant === NavbarRendererVariant.Mobile
                ? DropdownVariant.Mobile
                : DropdownVariant.Top
          }
          onNavigate={onNavigate}
        />
      );

    case NavItemType.Group:
      return (
        <Group
          item={item}
          variant={
            variant === NavbarRendererVariant.Mobile
              ? GroupVariant.Mobile
              : GroupVariant.Dropdown
          }
          onNavigate={onNavigate}
        />
      );

    case NavItemType.Action:
      return <NavLink item={item} variant={variant} onNavigate={onNavigate} />;

    case NavItemType.ProfileMenu:
      return null;

    default:
      return null;
  }
}
